import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import {observer} from 'mobx-react-lite';
import Modal from '../../../../../../components/modal';
import {AnchorStepComponent} from './Steps/AnchorStep';
import {LinkMediaStepComponent} from './Steps/LinkMediaStep';
import {MediaItem} from '../../../../models/MediaItem';
import {ExpandedPart} from '../../../../business/expanded_parts/ExpandedPartsProvider';
import {Anchor} from '../../../../models/Anchor';
import {Media} from '../../../../models/Media';

interface OwnProps {
    media: Media[];
    expandedPart: ExpandedPart;
    onAdd: (mediaItem: MediaItem) => void;
    onCancel: () => void;
}

enum WizardSteps {
    //Step 1
    LinkMedia,

    //Step 2
    Anchor,
}

interface LinkMediaStep {
    step: WizardSteps.LinkMedia;
}

interface AnchorStep {
    step: WizardSteps.Anchor;
    mediaItem: Omit<MediaItem, 'anchor' | 'playbackrate'>;
}

type Step = LinkMediaStep | AnchorStep;

export const AddMediaWizard: FunctionComponent<OwnProps> = observer(({media, expandedPart, onAdd, onCancel}) => {
    const [step, setStep] = useState<Step>({
        step: WizardSteps.LinkMedia,
    });

    function getContent(): JSX.Element {
        switch (step.step) {
            //Step 1
            case WizardSteps.LinkMedia:
                return (
                    <LinkMediaStepComponent
                        media={media}
                        onMediaItem={(mediaItem) =>
                            setStep({
                                step: WizardSteps.Anchor,
                                mediaItem: mediaItem,
                            })
                        }
                        onCancel={onCancel}
                    />
                );

            //Step 2
            case WizardSteps.Anchor:
                return (
                    <AnchorStepComponent
                        expandedPart={expandedPart}
                        onSubmit={(playbackrate, anchor) =>
                            onAdd({
                                __uuid: step.mediaItem.__uuid,
                                mediaId: step.mediaItem.mediaId,
                                playbackrate: playbackrate,
                                anchor: anchor,
                            })
                        }
                        onCancel={onCancel}
                    />
                );
        }
    }

    return (
        <Modal visible fluid onHide={onCancel}>
            {getContent()}
        </Modal>
    );
});
